import { FunctionComponent } from 'react'

const NewsletterPage: FunctionComponent = () => {
  return <div>Newsletter Page</div>
}

export default NewsletterPage
